/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

import ConditionalWrapperDivs from '../HelperComponents/ConditionalWrapperDivs';
/* Use this if the modal is simple, doesn't need a complex header, and has
minimal content. */

const ModalContentBasic = (props) => {
  const {
    className,
    title,
    titleLength,
    text,
    textLength,
    buttons,
    buttonsDisplay,
    children,
  } = props;

  return (
    <div className={`modalContentBasic ${className}`}>

      { title && (
        <h1 className={`modal__section modal__title modal__title--noCloseBtn modal__title--${titleLength}`}>
          {title}
        </h1>
      )}

      { text && (
        <div className={`modal__section modal__description modal__description--${textLength}`}>{ text }</div>
      )}

      { children }

      {buttons?.length > 0 && (
        <div className="modal__section modal__btns modal__btns--inline">
          <ConditionalWrapperDivs
            condition={buttonsDisplay === 'stacked'}
            classNamesArray={['modal__btns']} // Repeat class intentional to stack buttons
          >
            {buttons.map((button) => (
              <button
                key={button.key || button.text}
                className={button.className || 'modal__btn modal__btn--inline'}
                type="button"
                onClick={button.func}
              >
                {button.text}
              </button>
            ))}

          </ConditionalWrapperDivs>
        </div>
      )}
    </div>
  );
};

ModalContentBasic.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node,
  titleLength: PropTypes.oneOf(['short', 'long']),
  text: PropTypes.string,
  textLength: PropTypes.oneOf(['short', 'long']),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      func: PropTypes.func,
      text: PropTypes.string,
    }),
  ),
  buttonsDisplay: PropTypes.oneOf(['inline', 'stacked']),
};

ModalContentBasic.defaultProps = {
  className: '',
  title: null,
  titleLength: 'short',
  text: null,
  textLength: 'long',
  buttons: [],
  buttonsDisplay: 'inline',
};

export default ModalContentBasic;
